import * as React from "react";
const PersonalCareSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M9 6h5M9 6v2.5h5V6M9 6V4.5C9 3 10.5 2 12 2h5.5S14 3 14 5v1M6.5 9.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V19s0 3-3 3h-4c-3 0-3-3-3-3V9.5Z"
    />
  </svg>
);
export default PersonalCareSVG;
